import styled from 'styled-components'
import { STYLES } from '../../static/style'

const HeaderText1 = styled.h1`
  font-size: ${STYLES.HEADER_1_FONT_SIZE};
  line-height: ${STYLES.HEADER_1_LINE_HEIGHT};
`

const HeaderText2 = styled.h2`
  font-size: ${STYLES.HEADER_2_FONT_SIZE};
  line-height: ${STYLES.HEADER_2_LINE_HEIGHT};
`
const HeaderText3 = styled.h3`
  font-size: ${STYLES.HEADER_3_FONT_SIZE};
  line-height: ${STYLES.HEADER_3_LINE_HEIGHT};
`

const HeaderText4 = styled.h4`
  font-size: ${STYLES.HEADER_4_FONT_SIZE};
  line-height: ${STYLES.HEADER_4_LINE_HEIGHT};
`

const HeaderText5 = styled.h5`
  font-size: ${STYLES.HEADER_5_FONT_SIZE};
  line-height: ${STYLES.HEADER_5_LINE_HEIGHT};
  margin-bottom: 1.4rem;
`

const HeaderText6 = styled.h6`
  font-size: ${STYLES.HEADER_6_FONT_SIZE};
  line-height: ${STYLES.HEADER_6_LINE_HEIGHT};
`

export {
  HeaderText1,
  HeaderText2,
  HeaderText3,
  HeaderText4,
  HeaderText5,
  HeaderText6,
}
